import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(!_vm.loading)?_c(VIcon,{attrs:{"color":"accent","title":"ScDoc für Produktion herunterladen"},on:{"click":function($event){return _vm.downloadCadFile(_vm.articleId)}}},[_vm._v("\n\t\tfile_download\n\t")]):_c(VProgressCircular,{attrs:{"indeterminate":"","color":"accent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }